import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-screen flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <p className="font-serif text-7xl text-[var(--twr-bronze)]">404</p>
        <p className="eyebrow mt-6">Off the path</p>
        <h1 className="font-serif text-3xl mt-3">This room doesn't exist.</h1>
        <p className="text-[var(--twr-warm-white)]/65 mt-4">Let's get you back to a familiar door.</p>
        <Link to="/" className="btn-bronze mt-10 inline-flex">Return Home</Link>
      </div>
    </section>
  );
}
